import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";
import { ReduxRouter } from "@lagunovsky/redux-react-router";
import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import "mapbox-gl/dist/mapbox-gl.css";

import { routerSelector, store } from "./redux/store";
import Root from "./Root";
import { GlobalStyles, theme } from "./styles";
import { NotificationList } from "./components";
import { history } from "./redux/services";
import { initialize, registerAuthInterceptor } from "./services";

const root = createRoot(document.getElementById("root") as HTMLElement);

initialize();
registerAuthInterceptor();

root.render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <GlobalStyles />
        <ReduxRouter history={history} routerSelector={routerSelector}>
          <Root />
          <NotificationList />
        </ReduxRouter>
      </Provider>
    </ThemeProvider>
  </StrictMode>
);
